import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import { authGuard } from '../auth/authGuard';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/events',
    name: 'events',
    component: () => import(/* webpackChunkName: "events" */ '../views/Events.vue')
  },
  // {
  //   path: '/online-courses',
  //   name: 'onlinecourses',
  //   component: () => import(/* webpackChunkName: "onlinecourses" */ '../views/OnlineCourses.vue')
  // },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/support',
    name: 'support',
    component: () => import(/* webpackChunkName: "support" */ '../views/Support.vue')
  },
  {
    path: '/warranty',
    name: 'warranty',
    component: () => import(/* webpackChunkName: "warranty" */ '../views/Warranty.vue')
  },
  {
    path: '/event-videos',
    name: 'eventvideos',
    component: () => import(/* webpackChunkName: "eventvideos" */ '../views/EventVideos.vue')
  },
  {
    path: '/video-relay',
    name: 'videorelay/',
    component: () => import(/* webpackChunkName: "videorelay" */ '../views/VideoRelay.vue')
  },
  {
    path: '/video-discovery',
    name: 'videodiscovery/',
    component: () => import(/* webpackChunkName: "videodiscovery" */ '../views/VideoDiscovery.vue')
  },
  {
    path: '/video-comprehensive',
    name: 'videocomprehensive/',
    component: () => import(/* webpackChunkName: "videocomprehensive" */ '../views/VideoComprehensive.vue')
  },
  {
    path: '/video-interview',
    name: 'videointerview/',
    component: () => import(/* webpackChunkName: "videointerview" */ '../views/VideoInterview.vue')
  },
  {
    path: '/video-lab',
    name: 'videolab/',
    component: () => import(/* webpackChunkName: "videolab" */ '../views/VideoLab.vue')
  },
  {
    path: '/jg-crosby',
    name: 'jgcrosby/',
    component: () => import(/* webpackChunkName: "jgcrosby" */ '../views/JgCrosby.vue')
  },
  {
    path: '/jg-lobbedey',
    name: 'jglobbedey/',
    component: () => import(/* webpackChunkName: "jglobbedey" */ '../views/JgLobbedey.vue')
  },
  {
    path: '/shanafelt',
    name: 'shanafelt/',
    component: () => import(/* webpackChunkName: "shanafelt" */ '../views/Shanafelt.vue')
  },
  {
    path: '/mens-workout',
    name: 'mensworkout/',
    component: () => import(/* webpackChunkName: "mensworkout" */ '../views/MensWorkout.vue')
  },
  {
    path: '/working-the-system',
    name: 'workingthesystem/',
    component: () => import(/* webpackChunkName: "workingthesystem" */ '../views/WorkingTheSystem.vue')
  },
  {
    path: '/east-meets-west',
    name: 'eastmeetswest/',
    component: () => import(/* webpackChunkName: "eastmeetswest" */ '../views/EastMeetsWest.vue')
  },
  {
    path: '/exploring-extensions',
    name: 'exploringextensions/',
    component: () => import(/* webpackChunkName: "exploringextensions" */ '../views/ExploringExtensions.vue')
  },
  {
    path: '/exercise-progressions',
    name: 'exerciseprogressions/',
    component: () => import(/* webpackChunkName: "exerciseprogressions" */ '../views/ExerciseProgressions.vue')
  },
  {
    path: '/exercise-progressions-2',
    name: 'exerciseprogressions2/',
    component: () => import(/* webpackChunkName: "exerciseprogressions2" */ '../views/ExerciseProgressions2.vue')
  },
  {
    path: '/building-pull-up',
    name: 'buildingpullup/',
    component: () => import(/* webpackChunkName: "buildingpullup" */ '../views/BuildingPullUp.vue')
  },
  {
    path: '/tendon-stretch',
    name: 'tendonstretch/',
    component: () => import(/* webpackChunkName: "tenddonstretch" */ '../views/TendonStretch.vue')
  },
  {
    path: '/half-and-half',
    name: 'halfandhalf/',
    component: () => import(/* webpackChunkName: "halfandhalf" */ '../views/HalfAndHalf.vue')
  },
  {
    path: '/connecting',
    name: 'connecting/',
    component: () => import(/* webpackChunkName: "connecting" */ '../views/Connecting.vue')
  },
  {
    path: '/support-reformer',
    name: 'supportreformer',
    component: () => import(/* webpackChunkName: "supportreformer" */ '../views/SupportReformer.vue')
  },
  {
    path: '/support-reformer-with-tower',
    name: 'supportreformerwithtower',
    component: () => import(/* webpackChunkName: "supportreformerwithtower" */ '../views/SupportReformerWithTower.vue')
  },
  {
    path: '/support-cadillac',
    name: 'supportcadillac',
    component: () => import(/* webpackChunkName: "supportcadillac" */ '../views/SupportCadillac.vue')
  },
  {
    path: '/support-armchair',
    name: 'supportarmchair',
    component: () => import(/* webpackChunkName: "supportarmchair" */ '../views/SupportArmchair.vue')
  },
  {
    path: '/support-foldingmat',
    name: 'supportfoldingmat',
    component: () => import(/* webpackChunkName: "supportfoldingmat" */ '../views/SupportFoldingMat.vue')
  },
  {
    path: '/support-ladderbarrel',
    name: 'supportladderbarrel',
    component: () => import(/* webpackChunkName: "supportladderbarrel" */ '../views/SupportLadderBarrel.vue')
  },
  {
    path: '/support-wundachair',
    name: 'supportwundachair',
    component: () => import(/* webpackChunkName: "supportladderbarrel" */ '../views/SupportWundaChair.vue')
  },
  {
    path: '/support-pedopul',
    name: 'supportpedopul',
    component: () => import(/* webpackChunkName: "supportpedopul" */ '../views/SupportPedopul.vue')
  },
  {
    path: '/support-spinecorrector',
    name: 'supportspinecorrector',
    component: () => import(/* webpackChunkName: "supportspinecorrector" */ '../views/SupportSpineCorrector.vue')
  },
  {
    path: '/support-walltower',
    name: 'supportwalltower',
    component: () => import(/* webpackChunkName: "supportwalltower" */ '../views/SupportWallTower.vue')
  },
  {
    path: '/support-highmat',
    name: 'supporthighmat',
    component: () => import(/* webpackChunkName: "supporthighmat" */ '../views/SupportHighMat.vue')
  },
  {
    path: '/support-smallbarrel',
    name: 'supportsmallbarrel',
    component: () => import(/* webpackChunkName: "supportsmallbarrel" */ '../views/SupportSmallBarrel.vue')
  },
  {
    path: '/spring-circles',
    name: 'springcircles',
    component: () => import(/* webpackChunkName: "springcircles" */ '../views/SpringCircles.vue')
  },
  {
    path: '/toe-gizmo',
    name: 'toegizmo',
    component: () => import(/* webpackChunkName: "toegizmo" */ '../views/ToeGizmo.vue')
  },
  {
    path: '/demo-centers',
    name: 'democenters',
    component: () => import(/* webpackChunkName: "democenters" */ '../views/DemoCenters.vue')
  },
  {
    path: '/trainings',
    name: 'trainings',
    component: () => import(/* webpackChunkName: "trainings" */ '../views/Trainings.vue')
  },
  {
    path: '/add-event',
    name: 'addevent',
    component: () => import(/* webpackChunkName: "addevent" */ '../views/AddEvent.vue')
  },
  {
    path: '/add-site',
    name: 'addsite',
    component: () => import(/* webpackChunkName: "addsite" */ '../views/AddSite.vue')
  },
  {
    path: '/add-course',
    name: 'addcourse',
    component: () => import(/* webpackChunkName: "addcourse" */ '../views/AddCourse.vue')
  },
  {
    path: '/reformer',
    name: 'reformer',
    component: () => import(/* webpackChunkName: "reformer" */ '../views/Reformer.vue')
  },
  {
    path: '/wall-tower',
    name: 'walltower',
    component: () => import(/* webpackChunkName: "walltower" */ '../views/WallTower.vue')
  },
  {
    path: '/high-mat',
    name: 'highmat',
    component: () => import(/* webpackChunkName: "highmat" */ '../views/HighMat.vue')
  },
  {
    path: '/push-thru-bar-spring',
    name: 'pushthrubarspring',
    component: () => import(/* webpackChunkName: "pushthrubarspring" */ '../views/PushThruBarSpring.vue')
  },
  {
    path: '/spring-sleeves',
    name: 'springsleeves',
    component: () => import(/* webpackChunkName: "springsleeves" */ '../views/SpringSleeves.vue')
  },
  {
    path: '/folding-mat',
    name: 'foldingmat',
    component: () => import(/* webpackChunkName: "foldingmat" */ '../views/FoldingMat.vue')
  },
  {
    path: '/flash-cards',
    name: 'flashcards',
    component: () => import(/* webpackChunkName: "flashcards" */ '../views/FlashCards.vue')
  },
  {
    path: '/reformer-flash-cards',
    name: 'reformerflashcards',
    component: () => import(/* webpackChunkName: "reformerflashcards" */ '../views/ReformerFlashCards.vue')
  },
  {
    path: '/cadillac-flash-cards',
    name: 'cadillacflashcards',
    component: () => import(/* webpackChunkName: "cadillacflashcards" */ '../views/CadillacFlashCards.vue')
  },
  {
    path: '/chairs-flash-cards',
    name: 'chairsflashcards',
    component: () => import(/* webpackChunkName: "chairsflashcards" */ '../views/ChairsFlashCards.vue')
  },
  {
    path: '/barrels-flash-cards',
    name: 'barrelsflashcards',
    component: () => import(/* webpackChunkName: "barrelsflashcards" */ '../views/BarrelsFlashCards.vue')
  },
  {
    path: '/reformer-tower',
    name: 'reformertower',
    component: () => import(/* webpackChunkName: "reformertower" */ '../views/ReformerWithTower.vue')
  },
  {
    path: '/cadillac',
    name: 'cadillac',
    component: () => import(/* webpackChunkName: "cadillac" */ '../views/Cadillac.vue')
  },
  {
    path: '/arm-chair',
    name: 'armchair',
    component: () => import(/* webpackChunkName: "armchair" */ '../views/ArmChair.vue')
  },
  {
    path: '/spine-corrector',
    name: 'spinecorrector',
    component: () => import(/* webpackChunkName: "spinecorrector" */ '../views/SpineCorrector.vue')
  },
  {
    path: '/ladder-barrel',
    name: 'ladderbarrel',
    component: () => import(/* webpackChunkName: "ladderbarrel" */ '../views/LadderBarrel.vue')
  },
  {
    path: '/ped-o-pul',
    name: 'pedopul',
    component: () => import(/* webpackChunkName: "pedopul" */ '../views/PedOPul.vue')
  },
  {
    path: '/apparel',
    name: 'apparel',
    component: () => import(/* webpackChunkName: "apparel" */ '../views/Apparel.vue')
  },
  {
    path: '/accessories',
    name: 'accessories',
    component: () => import(/* webpackChunkName: "accessories" */ '../views/Accessories.vue')
  },
  {
    path: '/accessories/:id',
    name: 'accessory',
    component: () => import(/* webpackChunkName: "accessories" */ '../views/Accessories.vue')
  },
  {
    path: '/jumpboard',
    name: 'jumpboard',
    component: () => import(/* webpackChunkName: "jumpboard" */ '../views/Jumpboard.vue')
  },
  {
    path: '/footbar-cover',
    name: 'footbarcover',
    component: () => import(/* webpackChunkName: "footbarcover" */ '../views/FootbarCover.vue')
  },
  {
    path: '/ladder-barrel-platform',
    name: 'ladderbarrelplatform',
    component: () => import(/* webpackChunkName: "ladderbarrelplatform" */ '../views/LadderBarrelPlatform.vue')
  },
  {
    path: '/leather-handles',
    name: 'leatherhandles',
    component: () => import(/* webpackChunkName: "leatherhandles" */ '../views/LeatherHandles.vue')
  },
  {
    path: '/contoured-leather-handles',
    name: 'contouredleatherhandles',
    component: () => import(/* webpackChunkName: "contouredleatherhandles" */ '../views/ContouredLeatherHandles.vue')
  },
  {
    path: '/wire-contoured-handles',
    name: 'wirecontouredhandles',
    component: () => import(/* webpackChunkName: "wirecontouredhandles" */ '../views/WireContouredHandles.vue')
  },
  {
    path: '/mat-dowel-handles',
    name: 'dowelhandles',
    component: () => import(/* webpackChunkName: "dowelhandles" */ '../views/MatDowelHandles.vue')
  },
  {
    path: '/airplane-board',
    name: 'airplaneboard',
    component: () => import(/* webpackChunkName: "airplaneboard" */ '../views/AirplaneBoard.vue')
  },
  {
    path: '/kuna-board',
    name: 'kunaboard',
    component: () => import(/* webpackChunkName: "kunaboard" */ '../views/KunaBoard.vue')
  },
  {
    path: '/jpack-springs',
    name: 'jpacksprings',
    component: () => import(/* webpackChunkName: "jpacksprings" */ '../views/JpackSprings.vue')
  },
  {
    path: '/ped-o-pul-springs',
    name: 'pedopullsprings',
    component: () => import(/* webpackChunkName: "pedopullsprings" */ '../views/PedOPullSprings.vue')
  },
  {
    path: '/arm-chair-springs',
    name: 'armchairsprings',
    component: () => import(/* webpackChunkName: "armchairsprings" */ '../views/ArmChairSprings.vue')
  },
  {
    path: '/cadillac-leg-springs',
    name: 'cadillaclegsprings',
    component: () => import(/* webpackChunkName: "cadillaclegsprings" */ '../views/CadillacLegSprings.vue')
  },
  {
    path: '/cadillac-arm-springs',
    name: 'cadillacarmsprings',
    component: () => import(/* webpackChunkName: "cadillacarmsprings" */ '../views/CadillacArmSprings.vue')
  },
  {
    path: '/contrology-box',
    name: 'contrologybox',
    component: () => import(/* webpackChunkName: "contrologybox" */ '../views/ContrologyBox.vue')
  },
  {
    path: '/foam-wedge',
    name: 'foamwedge',
    component: () => import(/* webpackChunkName: "foamwedge" */ '../views/FoamWedge.vue')
  },
  {
    path: '/seat',
    name: 'seat',
    component: () => import(/* webpackChunkName: "seat" */ '../views/Seat.vue')
  },
  {
    path: '/tilting-base',
    name: 'tiltingbase',
    component: () => import(/* webpackChunkName: "tiltingbase" */ '../views/TiltingBase.vue')
  },
  {
    path: '/springs',
    name: 'springs',
    component: () => import(/* webpackChunkName: "springs" */ '../views/Springs.vue')
  },
  {
    path: '/joe-gym',
    name: 'joegym',
    component: () => import(/* webpackChunkName: "joegym" */ '../views/Joe\'sGym.vue')
  },
  {
    path: '/resources',
    name: 'resources',
    component: () => import(/* webpackChunkName: "joegym" */ '../views/Resources.vue')
  },
  {
    path: '/neck-stretcher',
    name: 'neckstretcher',
    component: () => import(/* webpackChunkName: "neckstretcher" */ '../views/NeckStretcher.vue')
  },
  {
    path: '/contrology-handbook',
    name: 'contrologyhandbook',
    component: () => import(/* webpackChunkName: "contrologyhandbook" */ '../views/ContrologyHandbook.vue')
  },
  {
    path: '/return-to-life',
    name: 'returntolife',
    component: () => import(/* webpackChunkName: "returntolife" */ '../views/ReturnToLife.vue')
  },
  {
    path: '/houston-event',
    name: 'houstonevent',
    redirect: "/houston-equipment",
  },
  {
    path: '/wunda-chair',
    name: 'wundachair',
    component: () => import(/* webpackChunkName: "wundachair" */ '../views/WundaChair.vue')
  },
  {
    path: '/small-barrel',
    name: 'smallbarrel',
    component: () => import(/* webpackChunkName: "smallbarrel" */ '../views/SmallBarrel.vue')
  },
  {
    path: '/edit',
    name: 'edit',
    component: () => import(/* webpackChunkName: "edit" */ '../views/Edit.vue')
  },
  {
    path: '/edit-select',
    name: 'editselect',
    component: () => import(/* webpackChunkName: "editselect" */ '../views/EditSelect.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/edit-events',
    name: 'editevents',
    component: () => import(/* webpackChunkName: "editevents" */ '../views/EditEvents.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/edit-sites',
    name: 'editsites',
    component: () => import(/* webpackChunkName: "editsites" */ '../views/EditSites.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/edit-courses',
    name: 'editcourses',
    component: () => import(/* webpackChunkName: "editcourses" */ '../views/EditCourses.vue'),
    beforeEnter: authGuard
  },
  {
    path: '*',
    name: 'notfound',
    component: () => import(/* webpackChunkName: "NotFound" */ '../views/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes
})

export default router
